import { graphql } from "@/lib/gql/__generated__";

export const SnackSettings_SnackSettingsPage_Query = graphql(`
	query SnackSettings_SnackSettings($hotelID: ID!) {
		snackSettings(hotelID: $hotelID) {
			id
			hotelID
			subDomain
			baseDomain
			ownerType
			validDtEnd
			gtmID
			topPageSnackUUID
		}
		snackBlocks(hotelID: $hotelID) {
			id
			hotelID
			uuid
			bgImage
			logoImage
			snsSetting {
				snsColor
				snsIcons {
					snsType
					url
				}
			}
			blocks {
				uuid
				title
				items {
					itemType
					itemUUID
					title
					thumbnail
				}
			}
			createdAt
			updatedAt
			isShowOriginalBgImage
			isShowLanguageSwitcher
		}
		hotel(hotelID: $hotelID) {
			companyID
		}
		guestPageVisibilitySettings(hotelID: $hotelID) {
			id
			hotelID
			plainVisibility
			magazineVisibility
			snackVisibility
		}
		snackList(hotelID: $hotelID) {
			id
			snacks {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
	}
`);
